export function isAudibleAutoplayPolicyRejection(error: unknown): boolean {
  return (
    typeof error === "object" &&
    error !== null &&
    "name" in error &&
    error.name === "NotAllowedError"
  );
}

export function isTimelinePlaybackToggleKey(key: string): boolean {
  return key === " " || key === "Spacebar";
}
